/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { createCashReceiptsIssue } from '../../../apis/cash-receipts';
import Form from '../../../components/Form';
import Modal, { ModalHeader } from '../../../components/Modal';
import { CSHPT_TRS_TYPE_CD, CSHPT_USG_CL_CD, SELF_TYPE_CD, SPST_CNFR_CL_CD } from '../../../constants/CASH_INVOICE';
import useForm from '../../../hooks/useForm';
import systemAlert from '../../../utils/systemAlert';
import { toast } from "../../../utils/toast";

const defaultForm = {
  selfTypeCd: "0",
  cshptUsgClCd: "0",
  cshptTrsTypeCd: "01",
  spstCnfrClCd: "01",
  spstCnfrNo: "",
  totaTrsAmt: "",
};

const CashInvoiceCreate = ({ open, setOpen, submit }) => {
  const [fields] = useState([
    [
      {
        title: "자진발급 여부",
        key: "selfTypeCd",
        type: 'radio',
        options: {
          list: SELF_TYPE_CD
        },
        required: true,
      },
    ],
    [
      {
        title: "용도",
        key: "cshptUsgClCd",
        type: 'radio',
        options: {
          list: CSHPT_USG_CL_CD
        },
        required: true,
      },
    ],
    [
      {
        title: "과세유형",
        key: "cshptTrsTypeCd",
        type: 'radio',
        options: {
          list: CSHPT_TRS_TYPE_CD
        },
        required: true,
      },
    ],
    [
      {
        title: "발급수단",
        key: "spstCnfrClCd",
        type: 'select',
        options: {
          list: SPST_CNFR_CL_CD
        },
        required: true,
      },
    ],
    [
      {
        title: '발급수단 번호',
        key: 'spstCnfrNo',
        type: 'number',
        required: true,
      }
    ],
    [
      {
        title: "총 거래금액",
        key: "totaTrsAmt",
        type: "input",
        validators: ['comma'],
        required: true,
      },
    ],
  ]);

  useEffect(() => {
    setValidateFields(fields);
  }, [open]);

  const _submit = (form) => {
    systemAlert('현금영수증을 발행하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            createCashReceiptsIssue(form).then(() => {
              toast.info('현금영수증 발행 되었습니다.');
              cancel();
              if (submit) {
                submit();
              }
            });
          }
        }
      ]
    });
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  const cancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (form.selfTypeCd === "0") {
      setForm({ spstCnfrNo: "0100001234", spstCnfrClCd: "03" });
    } else {
      setForm({ spstCnfrNo: "", spstCnfrClCd: "01" });
    };
  }, [form.selfTypeCd]);

  return (
    <>
      <Modal isOpen={open} close={cancel} size="md">
        <div className="cash-invoice-write">
          <ModalHeader>
            현금영수증 발급
          </ModalHeader>
          <Form
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            onChange={handleOnChange}
            submitText={'발급'}
            submit={handleSubmit}
            cancel={cancel}
          />
        </div>
      </Modal>
    </>
  );
};

export default CashInvoiceCreate;